import React, { PropsWithChildren, useRef, useState, useEffect, useCallback } from 'react';
import { makeStyles, createStyles } from '@material-ui/styles';
import { SvgIcon } from '../SvgIcon';
import { Theme } from '@material-ui/core';
import { checkStorage } from 'helpers/checkStorage';
import { storageService } from 'services/StorageService';
interface IProps {
  storageKey: string;
  title: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {},
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      transition: 'padding 0.5s ease-in-out, border-width 0.5s ease-in-out'
    },
    headerHiddenContent: {
      border: '1px solid #E0E0E0',
      borderRadius: 4,
      padding: 8
    },
    actions: {
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      border: 'none',
      background: 'transparent',
      fontSize: '0.875rem',
      fontWeight: 600,
      color: '#A3A3A3',
      cursor: 'pointer',
      '& svg': {
        fill: '#A3A3A3',
        width: 16,
        height: 16
      }
    },
    title: {
      color: theme?.variables?.colors['cardPrimaryColor'],
      fontSize: '1rem',
      fontWeight: 600
    },
    content: {
      marginTop: 14,
      overflow: 'hidden',
      transition: 'max-height 0.5s ease-out'
    }
  })
);
const Collapse: React.FC<PropsWithChildren<IProps>> = ({ title, children, storageKey }) => {
  const classes = useStyles();
  const [showContent, setShowContent] = useState(true);
  const [contentHeight, setContentHeight] = useState(0);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let showContentByStorage: string;

    if (checkStorage()) {
      showContentByStorage = storageService.getLocal(storageKey);
      setShowContent(JSON.parse(showContentByStorage) ?? true);
    }
    if (showContentByStorage === null) {
      return;
    }
  }, [storageKey]);

  useEffect(() => {
    if (contentRef?.current?.scrollHeight !== contentHeight) {
      setContentHeight(contentRef?.current?.scrollHeight + 10);
    }
  }, [contentRef, contentHeight]);

  const handleToggleCollapse = useCallback(() => {
    if (checkStorage()) {
      setShowContent(show => {
        storageService.setLocal(storageKey, JSON.stringify(!show));
        return !show;
      });
    }
  }, [storageKey]);

  return (
    <div className={classes.container}>
      <div className={`${classes.header} ${!showContent ? classes.headerHiddenContent : ''}`}>
        <div className={classes.title}>{title}</div>
        <button onClick={handleToggleCollapse} className={classes.actions}>
          <SvgIcon name={showContent ? 'eyeHide' : 'eyeShow'} />
          {showContent ? 'Ocultar' : 'Mostrar'}
        </button>
      </div>
      <div ref={contentRef} className={classes.content} style={{ maxHeight: showContent ? contentHeight : 0 }}>
        {children}
      </div>
    </div>
  );
};

export default React.memo(Collapse);
